import React, { useEffect, useState, useCallback } from 'react';
import RequestList from './components/requestList';
/* import Slide from '@mui/material/Slide'; */
import Dialog from '@mui/material/Dialog';
import { Button, Divider } from '@mui/material';
import i18n from '../../../../utils/i18n';
//REDUX
import { useSelector, useDispatch } from 'react-redux';
import RequestDialog from './components/requestDialog';
import classes from './ClientSection.module.scss';
import ACTIONS, {
	fetchProviderData,
	fetchProviderRequests,
	// addReqInfo,
} from '../../../../redux/action';
/* const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
}); */

const requestSortingHelper = [
	{ label: i18n.t('providerdashboard.openreqs2'), id: 'open' },
	{ label: i18n.t('providerdashboard.modifiedreqs'), id: 'modified' },
	{ label: i18n.t('providerdashboard.acceptedreqs'), id: 'accepted' },
	{ label: i18n.t('providerdashboard.declinedreqs'), id: 'declined' },
	{ label: i18n.t('providerdashboard.confirmedreqs'), id: 'confirmed' },
	{ label: i18n.t('providerdashboard.rejectedreqs'), id: 'rejected' },
];

const displayRequestLists = (requests, handleSelect) => {
	let reqLists = [];
	if (!requests || !requests.reqSorted) {
		return reqLists;
	}
	requestSortingHelper.forEach((item, i) => {
		if (requests.reqSorted[item.id] && requests.reqSorted[item.id].length > 0) {
			reqLists.push(
				<RequestList
					title={item.label}
					data={requests.reqSorted[item.id]}
					status={item.id}
					handleSelect={handleSelect}
					key={i}
				/>
			);
		}
	});
	return reqLists;
};
const ClientsSection = ({ ...props }) => {
	const dispatch = useDispatch();
	const [open, setOpen] = useState(false);
	const [selectedReq, setSelectedReq] = useState({});
	const reqInfo = useSelector((state) => state.reqInfo);
	const userData = useSelector((state) => state.userData);
	const requests = useSelector((state) => state.requests);
	const [reqSorted, setReqSorted] = useState(false);
	const JWT = localStorage.getItem('JWT');
	const handleSelect = (data) => {
		/*   console.log('parent data data', data); */
		setSelectedReq(data);
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	const fetchRequests = (data) => {
		dispatch(fetchProviderRequests(data));
	};

	const updateRequests = () => {
		dispatch(fetchProviderRequests({ JWT: JWT, id: userData.id }));
	};

		const sortRequests = useCallback(
		(requests) => {
			//console.log('sortRequests', requests);
			let reqInfo = {
				reqNumber: 0,
				open: 0,
				newCustomer: 0,
				reqSorted: {
					open: [],
					accepted: [],
					modified: [],
					confirmed: [],
					declined: [],
					rejected: [],
				},
			};
			let ID = userData?.id;
			if (!ID || !requests || !Array.isArray(requests)) {
				dispatch(
					ACTIONS.addReqInfo({
						data: reqInfo,
						stateObject: 'reqInfo',
					})
				);
				return;
			}
			requests.forEach((req) => {
				if (!req) return;
				reqInfo.reqNumber += 1;
				let reqStatus = '';
				let today = Date.parse(new Date());
				if (req.selected_providers && Array.isArray(req.selected_providers)) {
					req.selected_providers.forEach((prov) => {
						if (!prov) return;
						if (req.rfpdate) {
							req.timePassed = Math.floor(
								Math.abs(Date.parse(req.rfpdate) - today) / (1000 * 3600)
							);
						}
						if (prov.providerID === ID) {
							reqStatus = prov.requestStatus || '';
							if (prov.requestStatus === 'open') {
								reqInfo.open += 1;
							}
							if (prov.requestStatus === 'confirmed') {
								reqInfo.newCustomer += 1;
							}
							req.selected_providers = [prov];
						}
					});
				}
				// Only add to reqSorted if reqStatus is valid and exists in reqInfo.reqSorted
				if (reqStatus && reqInfo.reqSorted[reqStatus] !== undefined) {
					reqInfo.reqSorted[reqStatus] = [...reqInfo.reqSorted[reqStatus], req];
				}
			});
			for (let i in reqInfo.reqSorted) {
				if (Array.isArray(reqInfo.reqSorted[i])) {
					reqInfo.reqSorted[i] = reqInfo.reqSorted[i].reverse();
				}
			}
			dispatch(
				ACTIONS.addReqInfo({
					data: reqInfo,
					stateObject: 'reqInfo',
				})
			);
		},
		[userData?.id, dispatch]
	);

	useEffect(() => {
		if (requests?.length > 0 && userData.id) {
			sortRequests(requests);
		}
	}, [requests, userData.id, sortRequests]);

	useEffect(() => {
		window.scrollTo(0, 0);
		dispatch(
			fetchProviderRequests({
				JWT: JWT,
				id: userData.id,
			})
		);
	}, []);
	return (
		<div className={classes.dashboard}>
			<Dialog open={open} disableEscapeKeyDown={true}>
				<RequestDialog
					data={selectedReq}
					handleClose={handleClose}
					updateRequests={updateRequests}
				/>
			</Dialog>
			<div className={classes.title}>{i18n.t('general.requests')}</div>
			<Divider />
			<div className={classes.requestsContainer}>
				{displayRequestLists(reqInfo, handleSelect)}
			</div>
		</div>
	);
};

export default ClientsSection;
